module.exports = __webpack_public_path__ + "static/media/icon-moduleE10.7401188a.png";